import { createMutationHook } from '~/shared/providers/api';

export const useDeleteDriverMutation = createMutationHook(
  'transportation.driverDelete',
  (params: { id: string }) => ({
    transportationDriverDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
